import React from "react";
import { Typography } from "@mui/material";

const Home = () => {
    return <Typography variant="h4">Welcome to CrystalCompanion!</Typography>;
};

export default Home;
